import React from 'react';
import { connect, useSelector } from 'react-redux';
import _ from 'lodash';
import { getShowMonitoring } from './selectors';

// Higher-order component to check if a prop is defined
export const withPropCheck = (propName) => (Component) => {
  const WrappedComponent = (props) => {
    if (_.isNil(props[propName])) {
      throw new Error(`Property ${propName} must be specified on ${Component.displayName}`);
    }
    return <Component {...props} />;
  };
  WrappedComponent.displayName = `WithPropCheck(${propName})(${Component.displayName})`;
  return WrappedComponent;
};

// Higher-order component for deep comparison
export const withDeepCompareShouldUpdate = (Component) => {
  const eq=  React.memo(Component, (prevProps, nextProps) => {
    return !_.isEqual(prevProps, nextProps);
  });
  return eq;
};

// Higher-order component to connect showMonitoring from Redux
export const withShowMonitoring = (Component) => {
  const WrappedComponent = (props) => {
    const showMonitoring = useSelector(getShowMonitoring);
    //console.log('showMonEnhancer',showMonitoring)
    return <Component{...props} showMonitoring={showMonitoring}/>;
  };

  WrappedComponent.displayName = `WithShowMonitoring(${Component.displayName || Component.name||'Component'})`;
  return WrappedComponent;
};